export const BULK_ACTION_START = 'BULK_ACTION_START';
export const BULK_ACTION_FINISH = 'BULK_ACTION_FINISH';
export const BULK_ACTION_ERROR = 'BULK_ACTION_ERROR';
